import api from './api';

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface UserInfo {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  role: 'admin' | 'therapist';
  tenant_id: number | null;
  is_2fa_enabled: boolean;
}

export interface Enable2FAResponse {
  qr_code: string;
  backup_codes: string[];
}

export const authService = {
  async login(email: string, password: string, totpToken?: string): Promise<LoginResponse> {
    const response = await api.post('/auth/login', {
      email,
      password,
      totp_token: totpToken,
    });
    return response.data;
  },

  async getCurrentUser(): Promise<UserInfo> {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async setup2FA(): Promise<Enable2FAResponse> {
    const response = await api.post('/auth/setup-2fa');
    return response.data;
  },

  async enable2FA(totpToken: string): Promise<void> {
    await api.post('/auth/enable-2fa', {
      totp_token: totpToken,
    });
  },

  async disable2FA(totpToken: string): Promise<void> {
    await api.post('/auth/disable-2fa', {
      totp_token: totpToken,
    });
  },

  async refreshToken(refreshToken: string): Promise<LoginResponse> {
    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },
};